import React, { useState } from 'react';
import axios from 'axios';

const SendEmailForm = () => {
  const [aat, setAat] = useState('');
  const [email, setEmail] = useState('');
  const [nameTH, setNameTH] = useState('');
  const [surnameTH, setSurnameTH] = useState('');
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!aat || !email || !nameTH || !surnameTH) {
      setStatus('Please fill in all fields.');
      return;
    }

    const formData = new FormData();
    formData.append('aat', aat);
    formData.append('email', email);
    formData.append('nameTH', nameTH);
    formData.append('surnameTH', surnameTH);

    try {
      const res = await axios.post('/send-email-user', formData);
      setStatus(res.data.message || 'Email sent successfully!');
    } catch (err) {
      setStatus('Failed to send email. Please check your connection.');
    }
  };

  const inputStyle = {
    width: '100%',
    padding: '12px',
    marginBottom: '16px',
    backgroundColor: 'black',
    color: 'white',
    border: '1px solid #555',
    borderRadius: '5px',
    fontSize: '16px'
  };

  return (
    <div style={{ maxWidth: '500px', margin: '50px auto', padding: '24px', backgroundColor: '#1a1a1a', borderRadius: '10px', color: 'white' }}>
      <h2 style={{ marginBottom: '20px' }}>Send Member Info</h2>
      <form onSubmit={handleSubmit}>
        <label>AAT Number:</label>
        <input type="text" style={inputStyle} value={aat} onChange={e => setAat(e.target.value)} />

        <label>Email:</label>
        <input type="email" style={inputStyle} value={email} onChange={e => setEmail(e.target.value)} />

        <label>Name (Thai):</label>
        <input type="text" style={inputStyle} value={nameTH} onChange={e => setNameTH(e.target.value)} />

        <label>Surname (Thai):</label>
        <input type="text" style={inputStyle} value={surnameTH} onChange={e => setSurnameTH(e.target.value)} />

        <button type="submit" style={{ padding: '12px 24px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>
          Send Email
        </button>
      </form>
      {status && <p style={{ marginTop: '20px' }}>{status}</p>}
    </div>
  );
};

export default SendEmailForm;
